// ============================================================
// خروجی اکسل با دستور
//
// «خروجی اکسل صفحه اطلاعات خبازی رو بگیر» → همه‌ی رکوردها (نه فقط
// یک صفحه) گرفته می‌شود و فایل .xlsx دانلود می‌شود.
//
// ستون‌ها و عنوان از همان چیزی می‌آید که در گفتگو نشان داده می‌شود،
// پس فایل اکسل و جدول پنجره هیچ‌وقت از هم جدا نمی‌افتند. کلید هر
// ستون، *برچسب فارسی* است — چون در فایل اکسل همین می‌شود سرستون.
// ============================================================

import { exportToExcel } from "Common/Components/Excel";
import { Dataset, unpackRange, withinRange } from "./datasets";
import { todayJalali } from "./dates";

export interface ExportResult {
    fileName: string;
    count: number;
    title: string;
    /** اگر رکوردها به سقف اسکن خورده باشند */
    note?: string;
}

export const exportDataset = async (
    dataset: Dataset,
    values: Record<string, string>
): Promise<ExportResult> => {
    // یک صفحه می‌گیریم تا ستون‌ها و عنوان دقیقاً همان چیزی باشد که
    // کاربر در گفتگو دیده است.
    const preview = await dataset.run(values);

    let rows = dataset.fetchAll ? await dataset.fetchAll(values) : preview.rows;

    // fetchAll بازه‌ی تاریخ را نمی‌شناسد (مسیرهای سرور پارامتر تاریخ
    // ندارند)، پس همان فیلتر سمت کلاینت اینجا هم اعمال می‌شود.
    if (values.range && dataset.dateField) {
        const range = unpackRange(values.range);
        const field = dataset.dateField(values);
        rows = rows.filter((row: any) => withinRange(row[field], range));
    }

    const data = rows.map((row: any) => {
        const record: Record<string, any> = {};
        preview.columns.forEach((column) => {
            const value = row[column.key];
            record[column.label] = column.format ? column.format(value, row) : value;
        });
        return record;
    });

    const fileName = dataset.id + "-" + todayJalali().replace(/\//g, "-");
    exportToExcel(data, fileName);

    return {
        fileName: fileName + ".xlsx",
        count: data.length,
        title: preview.title,
        note: preview.note,
    };
};
